import { useTheme } from 'styled-components';
import { TOKEN_HTML_TAG } from '../constants';

export const useTokenStyles = () => {
  const theme = useTheme();
  return `
    ${TOKEN_HTML_TAG} {
      color: ${theme.colors.textColors.textPrimary};
      background-color: #d6d6d6;
      padding: 2.5px 5px;
      border-radius: 4px;
      cursor: grab !important;
      outline-color: #c3c3c5 !important;
      display: inline-flex;
      gap: 5px;
      align-items: center;
    }

    ${TOKEN_HTML_TAG}:active {
      cursor: grabbing !important;
    }

    ${TOKEN_HTML_TAG} img {
      height: 16px;
    }
  `;
};
